module.exports = __webpack_public_path__ + "img/product_114.2dc86dc.webp";